import script from "./ImportCompanyMatricule.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportCompanyMatricule.vue?vue&type=script&lang=ts&setup=true"

import "./ImportCompanyMatricule.vue?vue&type=style&index=0&id=053cc4e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053cc4e9"]])

export default __exports__